<template>
  <div class="about">
    <img src="./../../assets/image/logo.png" mode="aspectFill" />
    <p>{{ doorName }}</p>
    <p>1.0.0</p>
    <p>成都元素科技有限公司技术支持</p>
    <!-- <Back /> -->
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.about {
  height: 100vh;
  overflow: hidden;
  img {
    display: block;
    width: 70px;
    height: 70px;
    margin: 40px auto 0;
  }
  p {
    width: 100%;
    text-align: center;
  }
  p:nth-child(2) {
    font-size: 22px;
    font-weight: 800;
    color: #303133;
  }
  p:nth-child(3) {
    font-size: 13px;
    color: #303133;
    padding-top: 20rpx;
  }
  p:nth-child(4) {
    font-size: 14px;
    color: #909399;
    position: fixed;
    bottom: 50px;
  }
}
</style>
